<script setup lang="ts">

defineProps<{ value: string }>()
</script>

<template>
  <span class="font-medium text-gray-900 text-right break-normal">{{ value }}</span>
</template>
